<template>
  <div id="multi-size-ad" />
</template>

<script>
/* eslint-disable no-undef */

import { unitId } from '../../content'

export default {
  name: 'GptAd',

  mounted() {
    window.googletag = window.googletag || {cmd: []}
    googletag.cmd.push(function() {
      const mapping = googletag.sizeMapping()
        .addSize([1000, 0], [970, 250])
        .addSize([0, 0], [300, 250])
        .build()
      googletag
          .defineSlot(
              `/40175602/${unitId}`, [[300, 250], [970, 250]], 'multi-size-ad')
          .defineSizeMapping(mapping)
          .addService(googletag.pubads())
      googletag.pubads().enableSingleRequest()
      googletag.pubads().setCentering(true)
      googletag.enableServices()
    });

    googletag.cmd.push(function() {
        googletag.display('multi-size-ad')
      })
  }
}
</script>

<style lang="scss" scoped>
#multi-size-ad {
  padding-bottom: calc(10vh + 20px);
  @media screen and (min-width: 1024px) {
    padding-bottom: calc(10vh + 80px);
  }
  &:deep {
    iframe {
      display: inline;
    }
  }
}
</style>
